import DeviationLanguage from './DeviationLanguage';

interface Deviation {
    id: number;
    category: 'PA' | 'KPI' | 'PRP' | 'PRPD' | 'TRAINING' | 'COMMUNICATION' | 'GENERAL';
    description: string;
    languages: DeviationLanguage[];
}

const EmptyDeviation: Deviation = {
    id: 0,
    category: 'PA',
    description: '',
    languages: []
};

export { EmptyDeviation };

export default Deviation;
